import { render, staticRenderFns } from "./GVTag.vue?vue&type=template&id=5e8eabbb&scoped=true&"
import script from "./GVTag.vue?vue&type=script&lang=ts&"
export * from "./GVTag.vue?vue&type=script&lang=ts&"
import style0 from "./GVTag.vue?vue&type=style&index=0&id=5e8eabbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8eabbb",
  null
  
)

export default component.exports